/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_OverlineInputs */

const en_cp_ch_overline = /** @type {(inputs: Cp_Ch_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP BUILD CHALLENGE`)
};

const id_cp_ch_overline = /** @type {(inputs: Cp_Ch_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP BUILD CHALLENGE`)
};

/**
* | output |
* | --- |
* | "BYSTEP BUILD CHALLENGE" |
*
* @param {Cp_Ch_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_overline = /** @type {((inputs?: Cp_Ch_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_overline(inputs)
	return en_cp_ch_overline(inputs)
});